import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CrossTeamSharedModule } from '../../cross-team-shared/cross-team-shared.module';
import { Shared2DModule } from '../shared/shared-2d.module';
import { ImageContentInitializerComponent } from './image-content-initializer/image-content-initializer.component';
import { ImageOverlayDataComponent } from './image-overlay-data/image-overlay-data.component';
import { RasterRendererComponent } from './raster-renderer/raster-renderer.component';
import { PaintbrushSecondaryToolbarComponent } from './raster-tools/paintbrush-tool/paintbrush-secondary-toolbar.component';
import { SuperpixelSecondaryToolbarComponent } from './raster-tools/superpixel-tool/superpixel-secondary-toolbar.component';
import { EditModeButtonComponent } from './toolbars/layer-settings/edit-mode-button.component';
import { RasterCodingLayerViewSettingsPopoverComponent } from './toolbars/layer-settings/raster-coding-layer-view-settings-popover.component';
import { RasterCodingLayerViewSettingsComponent } from './toolbars/layer-settings/raster-coding-layer-view-settings.component';
import { MainRasterCodingToolbarComponent } from './toolbars/main-toolbars/main-raster-coding-toolbar.component';
import { TagOptionItemsComponent } from './toolbars/tag-option-items/tag-option-items.component';

const secondaryToolbars = [
  PaintbrushSecondaryToolbarComponent,
  SuperpixelSecondaryToolbarComponent,
];

const exportedItems = [
  EditModeButtonComponent,
  ImageContentInitializerComponent,
  ImageOverlayDataComponent,
  MainRasterCodingToolbarComponent,
  RasterCodingLayerViewSettingsPopoverComponent,
  RasterCodingLayerViewSettingsComponent,
  RasterRendererComponent,
  TagOptionItemsComponent,
];

@NgModule({
  imports: [
    CommonModule,
    CrossTeamSharedModule,
    FontAwesomeModule,
    FormsModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatTooltipModule,
    OverlayModule,
    PortalModule,
    Shared2DModule,
  ],
  declarations: [secondaryToolbars, exportedItems],
  exports: [exportedItems, Shared2DModule],
})
export class ImageContentModule {}
